import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@nextiva/next-ui';

import { Select, TextField } from '@nextiva/next-ui-admin';

import { DRAWER_MAKE_PAYMENT_DEFAULT } from 'constant';
import { states } from 'utils';

import './BillingInfo.scss';

export const blockName = 'billing-info';

const BillingInfo = ({
  firstName,
  lastName,
  billingAddress1,
  billingAddress2,
  city,
  usState,
  zipCode,
  setFirstName,
  setLastName,
  setBillingAddress1,
  setBillingAddress2,
  setCity,
  setUSState,
  setZipCode,
  isSummaryPage,
  shouldBeDefault,
  setShouldBeDefault,
  checkTextOnly,
  checkValidAddress,
  checkValidAddressNoMandatory,
  checkValidZipCode,
}) => (
  <div data-testid={blockName} className={blockName}>
    <Text kind="h4">Billing information</Text>
    <div
      className={`${blockName}__horizontal-fields ${blockName}__horizontal-fields--top-space`}
    >
      <TextField
        id="first-name"
        touchValidation
        value={firstName}
        className={`${blockName}__horizontal-fields--field-adjust`}
        label="First name"
        onChange={setFirstName}
        placeholder="First name"
        errorMessage="Insert First Name"
        validate={checkTextOnly}
      />
      <TextField
        id="last-name"
        touchValidation
        value={lastName}
        className={`${blockName}__horizontal-fields--field-adjust`}
        label="Last name"
        onChange={setLastName}
        placeholder="Last name"
        errorMessage="Insert Last Name"
        validate={checkTextOnly}
      />
    </div>
    <TextField
      id="billing-address1"
      touchValidation
      value={billingAddress1}
      className={`${blockName}__horizontal-fields--field-adjust`}
      label="Billing address 1"
      onChange={setBillingAddress1}
      placeholder="Billing address 1"
      errorMessage="This field should not be empty"
      validate={checkValidAddress}
    />
    <TextField
      id="billing-address2"
      touchValidation
      value={billingAddress2}
      className={`${blockName}__horizontal-fields--field-adjust`}
      label="Billing address 2"
      onChange={setBillingAddress2}
      placeholder="Billing address 2"
      errorMessage="Insert valid address"
      validate={checkValidAddressNoMandatory}
    />
    <div className={`${blockName}__horizontal-fields`}>
      <TextField
        id="city"
        touchValidation
        value={city}
        className={`${blockName}__horizontal-fields--field-adjust`}
        label="City"
        onChange={setCity}
        placeholder="City"
        errorMessage="This field should not be empty"
        validate={checkTextOnly}
      />
      <Select
        id="state"
        touchValidation
        value={usState}
        onChange={setUSState}
        label="State"
        placeholder="State"
        className={`${blockName}__horizontal-fields--field-adjust`}
        options={states}
        validate={checkTextOnly}
        errorMessage="Select a state"
      />
      <TextField
        id="zip-code"
        touchValidation
        value={zipCode}
        className={`${blockName}__horizontal-fields--field-adjust`}
        label="Zip Code"
        onChange={setZipCode}
        placeholder="Zip Code"
        errorMessage="Enter valid zip code"
        validate={checkValidZipCode}
      />
    </div>
    {isSummaryPage && (
      <div
        className={`${blockName}__default-section ${blockName}--big-top-space ${blockName}--hidden-section`}
      >
        <input
          type="checkbox"
          className={`${blockName}__make-default-checkbox ${blockName}--right-margin`}
          defaultChecked={shouldBeDefault}
          onClick={setShouldBeDefault}
        />{' '}
        <span>{DRAWER_MAKE_PAYMENT_DEFAULT}</span>
      </div>
    )}
  </div>
);

BillingInfo.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  billingAddress1: PropTypes.string.isRequired,
  billingAddress2: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  usState: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired,
  shouldBeDefault: PropTypes.bool.isRequired,
  isSummaryPage: PropTypes.bool.isRequired,
  setFirstName: PropTypes.func.isRequired,
  setLastName: PropTypes.func.isRequired,
  setBillingAddress1: PropTypes.func.isRequired,
  setBillingAddress2: PropTypes.func.isRequired,
  setCity: PropTypes.func.isRequired,
  setUSState: PropTypes.func.isRequired,
  setZipCode: PropTypes.func.isRequired,
  setShouldBeDefault: PropTypes.func.isRequired,
  checkTextOnly: PropTypes.func.isRequired,
  checkValidAddress: PropTypes.func.isRequired,
  checkValidAddressNoMandatory: PropTypes.func.isRequired,
  checkValidZipCode: PropTypes.func.isRequired,
};

export default BillingInfo;
